import React from "react";
// import { FMarketListData } from "../../../data/foreign/mainBoard/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { useDisplaySingleEmementStyles } from "../../useDisplaySingleEmementStyles";
import { useAuth } from "../../../data/auth/hooks";
import { useDisplayEtfComposition } from "../../../data/reports/securityStatistics/hooks/useDisplayEtfComposition";
import { formatDateFromISO } from "../../../core/util/functions";

export interface DisplayEtfCompositionProps {
	symbol?: string;
}

export const DisplayEtfComposition: React.FunctionComponent<DisplayEtfCompositionProps> = ({
	symbol,
}) => {
	const eftComposition = useDisplayEtfComposition(symbol);

	const style = useDisplaySingleEmementStyles();
	const { getString, getDateString, getDateTimeString, getFormatedNumberString, getFormatedNumberString4, getPercentString, getPercentStringDynamic4 } = React.useContext(
		LocalizationContext
	);

	const [auth] = useAuth();

	return (
		<div className={style.root}>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("majorMarketSectors")}</span>
				<span className={style.value}>{eftComposition?.major_market_sectors}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("countryAllocation")}</span>
				<span className={style.value}>{eftComposition?.countryAllocation}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("assetAllocationCash")}</span>
				<span className={style.value}> {getPercentString(eftComposition?.assetAllocationCash, false)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("assetAllocationStocks")}</span>
				<span className={style.value}> {getPercentString(eftComposition?.assetAllocationStocks, false)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("assetAllocationPreferred")}</span>
				<span className={style.value}> {getPercentString(eftComposition?.assetAllocationPreferred, false)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("assetAllocationConvertables")}</span>
				<span className={style.value}> {getPercentString(eftComposition?.assetAllocationConvertables, false)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("assetAllocationBonds")}</span>
				<span className={style.value}> {getPercentString(eftComposition?.assetAllocationBonds, false)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("assetAllocationOthers")}</span>
				<span className={style.value}> {getPercentString(eftComposition?.assetAllocationOthers)}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("topHolding")}</span>
				<span className={style.value}>{eftComposition?.topHolding}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("bondAverageMaturityFund")}</span>
				<span className={style.value}>{eftComposition?.bondAverageMaturityFund}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("bondAverageDurationFund")}</span>
				<span className={style.value}>{eftComposition?.bondAverageDurationFund}</span>
			</div>
			<div className={`${style.row} ${style.rowBorder}`}>
				<span className={style.label}>{getString("bondCreditQuality")}</span>
				<span className={style.value}>{eftComposition?.bondCreditQuality}</span>
			</div>
		</div>

	);
};

